import computed from 'flarum/common/utils/computed';
import Model from 'flarum/common/Model';
export default class Tag extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  slug() {
    return Model.attribute('slug').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  position() {
    return Model.attribute('position').call(this);
  }
  parent() {
    return Model.hasOne('parent').call(this);
  }
  children() {
    return Model.hasMany('children').call(this);
  }
  defaultSort() {
    return Model.attribute('defaultSort').call(this);
  }
  isChild() {
    return Model.attribute('isChild').call(this);
  }
  isHidden() {
    return Model.attribute('isHidden').call(this);
  }
  isPrimary() {
    return Model.attribute('isPrimary').call(this);
  }
  discussionCount() {
    return Model.attribute('discussionCount').call(this);
  }
  lastPostedAt() {
    return Model.attribute('lastPostedAt', Model.transformDate).call(this);
  }
  lastPostedDiscussion() {
    return Model.hasOne('lastPostedDiscussion').call(this);
  }
  isRestricted() {
    return Model.attribute('isRestricted').call(this);
  }
  canStartDiscussion() {
    return Model.attribute('canStartDiscussion').call(this);
  }
  canAddToDiscussion() {
    return Model.attribute('canAddToDiscussion').call(this);
  }
  isPrimaryParent() {
    return computed('position', 'parent', (position, parent) => position !== null && parent === false).call(this);
  }
}
flarum.reg.add('flarum-tags', 'common/models/Tag', Tag);